import './burgermenu.css';
// eslint-disable-next-line import/named
import { CustomUserClaim } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import { config } from "../../utils/config/config";
function ensureArray(customClaim: CustomUserClaim | CustomUserClaim[]): CustomUserClaim[] {
    // Vérifie si 'customClaim' est déjà un tableau
    // eslint-disable-next-line unicorn/prefer-ternary
    if (Array.isArray(customClaim)) {
        return customClaim;
    } else {
        // Si ce n'est pas un tableau, on l'encapsule dans un tableau
        return [customClaim];
    }
}
/**
 * @function BurgerMenu displays the mobile version of the navigation menu
 * @returns {JSX.Element} HTML content
 */
function BurgerMenu() {
    const { authState } = useOktaAuth();
    const groups = authState!.idToken!.claims.groups;
    // eslint-disable-next-line unicorn/consistent-function-scoping
    const handleNavigation = (path: string) => {
        window.location.href = path; // Change l'URL et recharge la page
    };

    const { oktaAuth } = useOktaAuth();
    const handleLogout = async () => {
      try {
        const redirectUri = window.location.origin;
        await oktaAuth.signOut({
          postLogoutRedirectUri: redirectUri + '/Account/PostLogout'
        });
      } catch (error) {
        console.error('Erreur lors de la tentative de connexion:', error);
      }
  
    };
      
    return (
        <ul className="navigationBar sm:hidden z-50 items-center">
            <li className="navigationElement" onClick={() => handleNavigation('/')}>Réservation</li>
                <li className="navigationElement" onClick={() => handleNavigation('/informations')}>Informations</li>
                <li className="navigationElement" onClick={() => handleNavigation('/charte')}>Charte Coworking</li>
                <li className="navigationElement" onClick={() => handleNavigation('/restaurants')}>Restaurants</li>
                {ensureArray(groups).includes(`GG_APCOWORK_${config.ENV_GROUP}_EDITOR`) ?
                <>
                    <li className="navigationElement" onClick={() => handleNavigation('/articles')}>Articles</li>
                </>
                : <>
                </>}
                <li className="navigationElement" onClick={() => void handleLogout()}>Se Déconnecter</li>
            {/* <Link to="/profil"><li className="burgerElement">Mon Profil</li></Link> */}
        </ul>
    );
}

export { BurgerMenu };